var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3232 48.7439L11.3427 48.4785H46.2054C47.6981 48.4785 49.05 47.7161 49.8177 46.439C50.1954 45.8173 50.4038 45.1066 50.4252 44.3798C50.4465 43.6673 50.2809 42.9566 49.9496 42.3243L49.93 42.2904L32.3508 9.10397C31.5831 7.87669 30.2382 7.125 28.7741 7.125C27.2083 7.125 25.7816 7.98356 25.0477 9.36581L7.61993 42.2904C7.27615 42.9335 7.10693 43.6549 7.12653 44.3798C7.14612 45.1048 7.35453 45.8173 7.73215 46.4372C8.10621 47.0642 8.63703 47.5825 9.26759 47.9388C9.89459 48.2915 10.6053 48.4785 11.3232 48.4785V48.7439ZM10.4575 44.7984L10.8725 44.0129L28.7741 10.1977L47.1013 44.7984H10.4575Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1641 20.0713L26.6016 20.0713L26.6016 32.54L30.1641 32.54L30.1641 20.0713Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2816 35.5093L26.6016 35.5093L26.6016 39.1876L30.2816 39.1876L30.2816 35.5093Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarning);
export default __webpack_public_path__ + "static/media/icons-warning.e6291b2909b0a514bd8fe8200d46e114.svg";
export { ForwardRef as ReactComponent };